import {type NavigationGuardNext, type RouteLocationNormalized} from "vue-router";
import {MarketNs} from "@shared/types/marketplace.namespace";
import {importProjectResolver} from "@domains/marketplace/resolvers";

export const marketRoutes = [
  {
    path: '/marketplace/import',
    name: MarketNs.MarketRouteEnums.MARKET_IMPORT,
    component: () => import('@shared/components/widgets/dummy.widget.vue'),
    props: true,
    beforeEnter: [
      (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
        importProjectResolver(to, from, next);
      }
    ]
  }
];
